/** 用户可见路径：论文工作区（内部实体仍叫 novelId / novels 表） */
export const PAPERS_PATH = '/papers'

export function paperPath(id?: string, rest = '') {
  if (!id) return PAPERS_PATH
  const suffix = rest ? (rest.startsWith('/') ? rest : `/${rest}`) : ''
  return `${PAPERS_PATH}/${id}${suffix}`
}
